.progressBar {
  height: 7px;
  background: var(--paletteWhite2);
  border-radius: var(--radiusMd);
  display: flex;
  overflow: hidden;
}

.valueLine {
  background: var(--palettePrimary0);
  height: 100%;
  transition: width 1s cubic-bezier(0.17, 0.67, 0.56, 0.94);
}
